export default __webpack_public_path__ + "static/media/ministerio-03-white.1ad7f7f7.svg";